// Klaviyo subscription helper
const KLAVIYO_SITE_ID = 'S8MmSD';

async function subscribeToKlaviyo(email) {
  try {
    await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_SITE_ID}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/vnd.api+json',
        'revision': '2026-01-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'TLE6kr'
              }
            }
          }
        }
      })
    });
  } catch (err) {
    console.error('Error subscribing to Klaviyo:', err);
  }
}

// Bundle discount tiers (matches bundle-builder logic)
function getBundleDiscountRate(count) {
  if (count >= 4) return 0.2;
  if (count === 3) return 0.15;
  if (count === 2) return 0.1;
  return 0;
}

// Product data mapping - maps product names to their details
const PRODUCT_DATA = {
  "new wash original": {
    name: "New Wash Original",
    imageUrl: "https://hairstory.com/cdn/shop/files/NWO_8_Product_-_Bottle.jpg",
    productUrl: "https://hairstory.com/products/new-wash-original",
    price: "$48",
    handle: "new-wash-original",
    sku: "850065187327",
    variantId: "45965755711718"
  },
  "new wash rich": {
    name: "New Wash Rich",
    imageUrl: "https://hairstory.com/cdn/shop/files/NWR8Product-Bottle.jpg",
    productUrl: "https://hairstory.com/products/new-wash-rich",
    price: "$48",
    handle: "new-wash-rich",
    sku: "850065187341",
    variantId: "45965800407270"
  },
  "new wash deep clean": {
    name: "New Wash Deep Clean",
    imageUrl: "https://hairstory.com/cdn/shop/files/NWD8Product-Bottle.jpg",
    productUrl: "https://hairstory.com/products/new-wash-deep-clean",
    price: "$48",
    handle: "new-wash-deep-clean",
    sku: "850065187334",
    variantId: "45965770522854"
  },
  "new wash fragrance-free": {
    name: "New Wash Fragrance-Free",
    imageUrl: "https://hairstory.com/cdn/shop/files/1-FF__BOTTLE_3.jpg",
    productUrl: "https://hairstory.com/products/new-wash-fragrance-free-8oz-bottle",
    price: "$48",
    handle: "new-wash-fragrance-free-8oz-bottle",
    sku: "850065187792",
    variantId: "47348263289062"
  },
  "pre-wash": {
    name: "Pre-Wash",
    imageUrl: "https://hairstory.com/cdn/shop/files/PREWASH.png",
    productUrl: "https://hairstory.com/products/pre-wash-4-oz",
    price: "$28",
    handle: "pre-wash-4-oz",
    sku: "850051150700",
    variantId: "45303092838630" 
  },
  "primer": {
    name: "Primer",
    imageUrl: "https://hairstory.com/cdn/shop/files/PRIMER_d73da503-c688-49fe-a869-1c9e936a9226.jpg",
    productUrl: "https://hairstory.com/products/primer-8-oz",
    price: "$36",
    handle: "primer-8-oz",
    sku: "850051150717",
    variantId: "45303092871398"
  },
  "hair balm": {
    name: "Hair Balm",
    imageUrl: "https://hairstory.com/cdn/shop/files/Hair_Balm.jpg",
    productUrl: "https://hairstory.com/products/hair-balm-4-oz",
    price: "$37",
    handle: "hair-balm-4-oz",
    sku: "850065187044",
    variantId: "45104210739430"
  },
  "oil": {
    name: "Oil",
    imageUrl: "https://hairstory.com/cdn/shop/files/Oil.jpg",
    productUrl: "https://hairstory.com/products/hair-oil-2-oz-refill",
    price: "$37",
    handle: "hair-oil-2-oz-refill",
    sku: "850065187099",
    variantId: "45104210772198"
  },
  "undressed": {
    name: "Undressed",
    imageUrl: "https://hairstory.com/cdn/shop/files/Undressed.jpg",
    productUrl: "https://hairstory.com/products/undressed-8-oz",
    price: "$38",
    handle: "undressed-8-oz",
    sku: "850065187051",
    variantId: "45104456106214"
  },
  "powder": {
    name: "Powder",
    imageUrl: "https://hairstory.com/cdn/shop/files/Powder.jpg",
    productUrl: "https://hairstory.com/products/powder",
    price: "$37",
    handle: "powder",
    sku: "850065187075",
    variantId: "45104456007910"
  },
  "root lift": {
    name: "Root Lift",
    imageUrl: "https://hairstory.com/cdn/shop/files/RootLIFT.jpg",
    productUrl: "https://hairstory.com/products/lift-8-oz",
    price: "$38",
    handle: "lift-8-oz",
    sku: "850065187082",
    variantId: "45104455450854"
  },
  "wax": {
    name: "Wax",
    imageUrl: "https://hairstory.com/cdn/shop/files/WAX.jpg",
    productUrl: "https://hairstory.com/products/wax-2-oz",
    price: "$29",
    handle: "wax-2-oz",
    sku: "850065187068",
    variantId: "45104456204518"
  },
  "bond serum": {
    name: "Bond Serum",
    imageUrl: "https://hairstory.com/cdn/shop/files/PS_Bond-Serum-2oz.jpg",
    productUrl: "https://hairstory.com/products/bond-serum-2-oz",
    price: "$44",
    handle: "bond-serum-2-oz",
    sku: "850065187020",
    variantId: "45475329179878"
  },
  "styling gel": {
    name: "Styling Gel",
    imageUrl: "https://hairstory.com/cdn/shop/files/Styling_gel_8oz.jpg",
    productUrl: "https://hairstory.com/products/styling-gel-bottle",
    price: "$34",
    handle: "styling-gel-bottle",
    sku: "850065187778",
    variantId: "46688025510118" 
  }
};

// Helper function to find product data by name (case-insensitive, flexible matching)
function getProductData(productName) {
  const normalizedName = productName.toLowerCase().trim();

  // Direct match
  if (PRODUCT_DATA[normalizedName]) {
    return PRODUCT_DATA[normalizedName];
  }

  // Partial match - find if the product name contains or is contained in the key
  for (const [key, value] of Object.entries(PRODUCT_DATA)) {
    if (normalizedName.includes(key) || key.includes(normalizedName)) {
      return value;
    }
  }

  // Return default/fallback
  return {
    name: productName,
    imageUrl: null,
    productUrl: null,
    price: null
  };
}

class HairChat extends HTMLElement {
  static get observedAttributes() {
    return ['test-mode', 'system-prompt', 'model'];
  }

  constructor() {
    super();
    this.messages = [];
    this.isTyping = false;
    this.conversationHistory = [];
    // Generate session ID for tracking in platform
    this.sessionId = this.getAttribute('session-id') || `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    // Single AI badge element
    this.aiBadge = null;
  }

  updateConfig() {
    this.testMode = this.getAttribute('test-mode') === 'true' || false;
    this.customSystemPrompt = this.getAttribute('system-prompt') || null;
    this.customModel = this.getAttribute('model') || null;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.updateConfig();
    }
  }

  connectedCallback() {
    this.initializeComponent();
    this.updateConfig();

    // Fire GTM event when chat loads
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'aichat_started',
        session_id: this.sessionId
      });
    }
  }

  initializeComponent() {
    this.messagesContainer = this.querySelector('.chat-messages');
    this.inputField = this.querySelector('.chat-input');
    this.sendButton = this.querySelector('.send-button');
    this.emptyState = this.querySelector('.empty-state');
    this.startOverBtn = this.querySelector('.start-over-btn');

    // Get the AI badge from empty state
    this.aiBadge = this.querySelector('.expert-badge');

    // Get all product modals
    this.productModals = this.querySelectorAll('[data-product-modal-handle]');

    this.attachEventListeners();
    this.initializeProductModals();
    this.autoResizeTextarea();
    this.updateEmptyStateClass();
  }

  attachEventListeners() {
    this.sendButton.addEventListener('click', () => this.handleSendMessage());
    this.startOverBtn.addEventListener('click', () => this.resetChat());

    this.inputField.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.handleSendMessage();
      }
    });

    this.inputField.addEventListener('input', () => this.autoResizeTextarea());

    // Event delegation for product clicks
    this.messagesContainer.addEventListener('click', (e) => {
      // Handle product info trigger (opens modal)
      const productInfoTrigger = e.target.closest('[data-product-info-trigger]');
      if (productInfoTrigger) {
        e.preventDefault();
        const handle = productInfoTrigger.dataset.productInfoTrigger;
        this.showProductModal(handle);
        return;
      }

      const productCard = e.target.closest('[data-product-click]');
      if (productCard) {
        e.preventDefault();
        const routineUrl = productCard.dataset.routineUrl;
        const clickType = productCard.dataset.clickType;
        const productSkus = JSON.parse(productCard.dataset.productSkus);

        // Fire GTM event
        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer.push({
            event: 'aichat_completed',
            session_id: this.sessionId,
            product_skus: productSkus,
            click_type: clickType
          });
        }

        // Handle add bundle button differently from customize link
        if (clickType === 'add_bundle_button') {
          // Add bundle to cart
          this.addCustomBundle(productSkus, productCard);
        } else {
          // Navigate to routine URL for customize link
          window.location.href = routineUrl;
        }
      }

      // Handle quick-start button clicks
      const quickStartBtn = e.target.closest('.quick-start-btn');
      if (quickStartBtn) {
        const value = quickStartBtn.dataset.value;
        this.handleQuickStartClick(value);
      }

      // Handle "Save your bundle" trigger click
      const saveBundleTrigger = e.target.closest('[data-save-bundle-trigger]');
      if (saveBundleTrigger) {
        e.preventDefault();
        const ctaContainer = saveBundleTrigger.closest('[data-save-bundle]');
        if (ctaContainer) {
          ctaContainer.querySelector('.save-bundle-collapsed').style.display = 'none';
          ctaContainer.querySelector('.save-bundle-expanded').style.display = 'block';
          const emailInput = ctaContainer.querySelector('.save-bundle-email');
          if (emailInput) emailInput.focus();

          if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
              event: 'aichat_save_bundle_click',
              session_id: this.sessionId
            });
          }
        }
      }
    });

    // Event delegation for save-bundle form submission
    this.messagesContainer.addEventListener('submit', (e) => {
      const saveBundleForm = e.target.closest('[data-save-bundle-form]');
      if (saveBundleForm) {
        e.preventDefault();
        this.handleSaveBundleSubmit(saveBundleForm);
      }
    });
  }

  initializeProductModals() {
    if (!this.productModals || !this.productModals.length) return;

    this.productModals.forEach(modal => {
      // Close button handlers (X button and Back to Chat button)
      const closeBtns = modal.querySelectorAll('[data-modal-close]');
      closeBtns.forEach(btn => {
        btn.addEventListener('click', () => this.closeProductModal(modal));
      });

      // Backdrop click handler
      const backdrop = modal.querySelector('[data-modal-backdrop]');
      if (backdrop) {
        backdrop.addEventListener('click', (e) => {
          if (e.target === backdrop) {
            this.closeProductModal(modal);
          }
        });
      }
    });

    // ESC key handler
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const openModal = Array.from(this.productModals).find(
          modal => !modal.classList.contains('hidden')
        );
        if (openModal) {
          this.closeProductModal(openModal);
        }
      }
    });
  }

  showProductModal(handle) {
    const modal = Array.from(this.productModals).find(
      m => m.dataset.productModalHandle === handle
    );

    if (modal) {
      modal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';

      // Fire GTM event
      const productEntry = Object.values(PRODUCT_DATA).find(p => p.handle === handle);
      if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
          event: 'aichat_product_modal_view',
          session_id: this.sessionId,
          modal_product_sku: productEntry ? productEntry.sku : handle
        });
      }
    }
  }

  closeProductModal(modal) {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  handleQuickStartClick(value) {
    // Prevent clicks while AI is responding
    if (this.isTyping) return;

    // Disable all quick-start buttons
    const buttons = this.querySelectorAll('.quick-start-btn');
    buttons.forEach(btn => {
      btn.disabled = true;
      if (btn.dataset.value === value) {
        btn.classList.add('selected');
      }
    });

    // Convert empty state to message if needed
    if (this.messages.length === 0) {
      this.convertEmptyStateToMessage();
    }

    // Send the selected value as user message
    this.addMessage(value, 'user');

    // Add to conversation history
    this.conversationHistory.push({
      role: 'user',
      content: value
    });

    // Get AI response
    this.getAIResponse();
  }

  updateEmptyStateClass() {
    if (this.emptyState && this.emptyState.style.display !== 'none') {
      this.messagesContainer.classList.add('empty-state-active');
    } else {
      this.messagesContainer.classList.remove('empty-state-active');
    }
  }

  autoResizeTextarea() {
    const textarea = this.inputField;
    textarea.style.height = 'auto';
    const newHeight = Math.min(textarea.scrollHeight, 180);
    textarea.style.height = newHeight + 'px';

    // Only show scrollbar if content exceeds max height
    if (newHeight >= 180) {
      textarea.style.overflowY = 'auto';
    } else {
      textarea.style.overflowY = 'hidden';
    }

    this.sendButton.disabled = !textarea.value.trim();
  }

  resetChat() {
    this.messages = [];
    this.conversationHistory = [];
    // Generate new session ID on reset
    this.sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    this.messagesContainer.innerHTML = `
      <div class="empty-state">
        <div class="empty-state-greeting">
          Hey there 👋 Let's find your perfect hair routine (and save up to 20%).
        </div>
        <div class="empty-state-question">
          What's your biggest hair struggle?
        </div>
        <div class="quick-start-buttons">
          <button class="quick-start-btn" data-value="Frizz">Frizz</button>
          <button class="quick-start-btn" data-value="Oiliness">Oiliness</button>
          <button class="quick-start-btn" data-value="Dryness">Dryness</button>
          <button class="quick-start-btn" data-value="Flat/No volume">Flat/No volume</button>
          <button class="quick-start-btn" data-value="Damage/Breakage">Damage/Breakage</button>
          <button class="quick-start-btn" data-value="Color fading">Color fading</button>
          <button class="quick-start-btn" data-value="Nothing specific">Nothing specific</button>
        </div>
        <div class="or-type-text">Or describe it in your own words below</div>
        <div class="expert-badge">
          <img src="/ai-profile.svg" alt="AI" width="28" height="28">
        </div>
      </div>
    `;
    this.emptyState = this.querySelector('.empty-state');
    this.inputField.value = '';
    this.autoResizeTextarea();
    this.hasInteracted = false;
    this.updateEmptyStateClass();

    // Dispatch custom event so React can update session ID display
    this.dispatchEvent(new CustomEvent('session-reset', {
      detail: { sessionId: this.sessionId },
      bubbles: true
    }));
  }

  async handleSendMessage() {
    const message = this.inputField.value.trim();
    if (!message) return;

    // Prevent sending while AI is responding
    if (this.isTyping) return;

    if (this.messages.length === 0) {
      this.convertEmptyStateToMessage();

      // Fire GTM event for first prompt submission
      if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
          event: 'aichat_prompt_submitted',
          session_id: this.sessionId
        });
      }
    }

    this.addMessage(message, 'user');

    this.inputField.value = '';
    this.autoResizeTextarea();

    // Add user message to conversation history
    this.conversationHistory.push({
      role: 'user',
      content: message
    });

    await this.getAIResponse();
  }

  convertEmptyStateToMessage() {
    this.emptyState.style.display = 'none';
    this.updateEmptyStateClass();

    const openingMessage = "Hey there 👋 Let's find your perfect hair routine (and save up to 20%).\n\nWhat's your biggest hair struggle?";

    const messageData = {
      content: openingMessage,
      sender: 'ai',
      timestamp: new Date()
    };

    this.messages.push(messageData);
    this.renderMessage(messageData, false); // Don't add badge to message

    // Move badge after the message
    const lastMessage = this.messagesContainer.querySelector('.message.ai:last-child .message-content');
    if (lastMessage && this.aiBadge) {
      lastMessage.appendChild(this.aiBadge);
    }

    // Add initial system message to conversation history
    this.conversationHistory.push({
      role: 'assistant',
      content: openingMessage
    });
  }

  addMessage(content, sender, recommendation = null) {
    const messageData = {
      content,
      sender,
      timestamp: new Date(),
      recommendation
    };

    this.messages.push(messageData);
    const messageElement = this.renderMessage(messageData, true); // Always add badge for new messages

    // Scroll behavior: for AI messages, show user's question + AI response
    if (sender === 'ai') {
      this.scrollToMessage(messageElement);
    } else {
      this.scrollToBottom();
    }
  }

  renderMessage(messageData, shouldMoveBadge = true) {
    const messageElement = document.createElement('div');
    messageElement.className = `message ${messageData.sender}`;

    const content = document.createElement('div');
    content.className = 'message-content';

    if (messageData.sender === 'ai') {
      // Check if this message has structured recommendation data (from tool calling)
      if (messageData.recommendation && messageData.recommendation.products) {
        // Render product cards from structured data
        const productsHtml = this.renderProductCardsFromJson(
          { products: messageData.recommendation.products },
          messageData.recommendation.intro,
          messageData.recommendation.closing,
          messageData.recommendation.review
        );
        const wrapper = document.createElement('div');
        wrapper.innerHTML = productsHtml;
        content.appendChild(wrapper);
      } else if (messageData.content) {
        // Check for legacy JSON code block format (fallback)
        const jsonMatch = messageData.content.match(/```json\s*([\s\S]*?)\s*```/);

        if (jsonMatch) {
          const jsonData = this.tryParseJson(jsonMatch[1]);
          if (jsonData) {
            const beforeJson = messageData.content.substring(0, jsonMatch.index).trim();
            const afterJson = messageData.content.substring(jsonMatch.index + jsonMatch[0].length).trim();

            const productsHtml = this.renderProductCardsFromJson(jsonData, beforeJson, afterJson, null);
            const wrapper = document.createElement('div');
            wrapper.innerHTML = productsHtml;
            content.appendChild(wrapper);
          } else {
            // If JSON parsing fails, render as regular message
            console.error('Failed to parse product JSON');
            const text = document.createElement('div');
            const formattedText = messageData.content.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
            text.innerHTML = this.linkifyUrls(formattedText);
            content.appendChild(text);
          }
        } else {
          // Regular message
          const text = document.createElement('div');
          const formattedText = messageData.content.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
          text.innerHTML = this.linkifyUrls(formattedText);
          content.appendChild(text);
        }
      }

      // Move the badge to this message
      if (shouldMoveBadge && this.aiBadge) {
        content.appendChild(this.aiBadge);
      }
    } else {
      content.textContent = messageData.content;
    }

    messageElement.appendChild(content);
    this.messagesContainer.appendChild(messageElement);
    return messageElement;
  }

  renderProductCardsFromJson(jsonData, beforeText, afterText, reviewData = null) {
    // Build intro text
    const intro = beforeText || 'Here are my recommendations for you:';

    // Build product cards HTML
    let html = `<div class="product-cards-intro">${this.linkifyUrls(intro)}</div>`;

    // Separate essential and additional products
    const essentialProducts = [];
    const additionalProducts = [];

    if (jsonData.products && Array.isArray(jsonData.products)) {
      jsonData.products.forEach((product, index) => {
        if (index < 2) {
          essentialProducts.push(product);
        } else {
          additionalProducts.push(product);
        }
      });
    }

    // Build routine URL with all product handles
    const handles = [];
    const skus = [];
    let totalPrice = 0;

    if (jsonData.products && Array.isArray(jsonData.products)) {
      jsonData.products.forEach(product => {
        const productData = getProductData(product.name);
        if (productData.handle) {
          handles.push(productData.handle);
        }
        if (productData.sku) {
          skus.push(productData.sku);
        }
        if (productData.price) {
          totalPrice += parseFloat(productData.price.replace('$', ''));
        }
      });
    }
    const routineUrl = `https://hairstory.com/pages/bundle-builder?view=routine&routine=${handles.join(',')}`;

    // Store recommendation data for later use in email capture
    this.lastRecommendation = jsonData;
    this.lastRecommendationIntro = beforeText || '';
    this.lastRecommendationClosing = afterText || '';
    this.lastRecommendationRoutineUrl = routineUrl;

    // Fire GTM event for product recommendations
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'aichat_skus_recommended',
        product_skus: skus,
        product_count: jsonData.products.length,
        session_id: this.sessionId
      });
    }

    // Render Essential Products section
    if (essentialProducts.length > 0) {
      html += `<div class="product-section-title">Essential Products (${essentialProducts.length})</div>`;
      essentialProducts.forEach(product => {
        // Get product data from our mapping
        const productData = getProductData(product.name);
        const imageUrl = productData.imageUrl || `/product-images/${this.slugify(product.name)}.jpg`;

        html += `
          <div class="product-card"
               data-product-info-trigger="${productData.handle || ''}"
               style="cursor: pointer;">
            <div class="product-card-image">
              <img src="${imageUrl}" alt="${productData.name}" onerror="this.style.display='none'">
            </div>
            <div class="product-card-content">
              <h3 class="product-name">${productData.name}</h3>
              <div class="product-description">
                ${product.description}
              </div>
              <a class="product-learn-more" href="#">LEARN MORE</a>
            </div>
          </div>
        `;
      });
    }

    // Render Additional Recommendations section
    if (additionalProducts.length > 0) {
      html += `<div class="product-section-title">Additional Recommendations (${additionalProducts.length})</div>`;
      additionalProducts.forEach(product => {
        // Get product data from our mapping
        const productData = getProductData(product.name);
        const imageUrl = productData.imageUrl || `/product-images/${this.slugify(product.name)}.jpg`;

        html += `
          <div class="product-card"
               data-product-info-trigger="${productData.handle || ''}"
               style="cursor: pointer;">
            <div class="product-card-image">
              <img src="${imageUrl}" alt="${productData.name}" onerror="this.style.display='none'">
            </div>
            <div class="product-card-content">
              <h3 class="product-name">${productData.name}</h3>
              <div class="product-description">
                ${product.description}
              </div>
              <a class="product-learn-more" href="#">LEARN MORE</a>
            </div>
          </div>
        `;
      });
    }

    // Add closing text
    if (afterText) {
      html += `<div class="product-cards-footer">${this.linkifyUrls(afterText)}</div>`;
    }

    // Add savings text - dynamic based on number of products
    const totalProducts = jsonData.products ? jsonData.products.length : 0;
    let discount = 0;
    if (totalProducts === 3) {
      discount = 0.15;
      html += `<div class="product-savings">Oh and when you bundle all ${totalProducts} you <strong>save 15%</strong>.</div>`;
    } else if (totalProducts >= 4) {
      discount = 0.20;
      html += `<div class="product-savings">Oh and when you bundle all ${totalProducts} you <strong>save 20%</strong>.</div>`;
    }

    // Calculate prices (using placeholder prices for now)
    // TODO: Replace with actual product prices from PRODUCT_DATA
    const originalPrice = totalPrice > 0 ? totalPrice : 180; // Fallback to $180 if no prices available
    const discountedPrice = originalPrice * (1 - discount);

    // Add Bundle to Cart button with prices
    html += `
      <button class="add-bundle-btn"
              data-product-click
              data-routine-url="${routineUrl}"
              data-click-type="add_bundle_button"
              data-product-skus='${JSON.stringify(skus)}'>
        ADD <span class="bundle-text">BUNDLE </span>TO CART – <span class="btn-price-original">$${originalPrice.toFixed(2)}</span> <span class="btn-price-discounted">$${discountedPrice.toFixed(2)}</span>
      </button>
    `;

    // Customize Bundle button
    html += `
      <a href="${routineUrl}" class="customize-bundle-btn"
        data-product-click
        data-routine-url="${routineUrl}"
        data-click-type="customize_link"
        data-product-skus='${JSON.stringify(skus)}'>CUSTOMIZE BUNDLE</a>
    `;

    // Save your bundle email capture CTA
    html += `
      <div class="save-bundle-cta" data-save-bundle data-product-skus='${JSON.stringify(skus)}'>
        <div class="save-bundle-collapsed">
          <span class="save-bundle-link" data-save-bundle-trigger>
            Save your bundle &mdash; <span class="save-bundle-underline">email me this recommendation</span>
          </span>
        </div>
        <div class="save-bundle-expanded" style="display: none;">
          <div class="save-bundle-form-label">
            Get your personalized bundle sent to your inbox:
          </div>
          <form class="save-bundle-form" data-save-bundle-form>
            <div class="save-bundle-input-row">
              <input
                type="email"
                class="save-bundle-email"
                placeholder="Email address"
                required
                pattern="^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$"
              />
              <button type="submit" class="save-bundle-submit">Send</button>
            </div>
            <div class="save-bundle-disclaimer">
              By submitting my email address, I consent to receive special offers, newsletters, and updates via email. For more information, please consult our
              <a href="https://hairstory.com/pages/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              and
              <a href="https://hairstory.com/pages/terms-of-use" target="_blank" rel="noopener noreferrer">Terms and Conditions.</a>
            </div>
          </form>
        </div>
        <div class="save-bundle-success" style="display: none;">
          <span class="save-bundle-check">✓</span> Sent! Check your inbox.
        </div>
      </div>
    `;

    // Add customer review card if available
    if (reviewData) {
      html += `
        <div class="review-card">
          <div class="review-header">
            <div class="review-rating">
              ${'★'.repeat(5)}
            </div>
            <div class="review-meta">
              <span class="review-author">${this.escapeHtml(reviewData.reviewer_name || 'Anonymous')}</span>
              ${reviewData.hair_type ? `<span class="review-hair-type">${this.escapeHtml(reviewData.hair_type)}</span>` : ''}
            </div>
          </div>
          ${reviewData.review_title ? `<div class="review-title">${this.escapeHtml(reviewData.review_title)}</div>` : ''}
          <div class="review-content">${this.escapeHtml(reviewData.review_content)}</div>
          ${reviewData.product_title ? `<div class="review-product">Review for: ${this.escapeHtml(reviewData.product_title)}</div>` : ''}
        </div>
      `;
    }

    return html;
  }

  escapeHtml(text) {
    if (!text) return '';

    // First decode any HTML entities that might be in the text
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    let decoded = textarea.value;

    // Escape special HTML characters for safe rendering
    const escaped = decoded
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    // Convert newlines to <br> tags
    return escaped.replace(/\n/g, '<br>');
  }

  slugify(text) {
    return text.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  tryParseJson(jsonString) {
    // First try strict parsing
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      // Try to repair common errors
      let repaired = jsonString
        // Fix array closed with } instead of ]
        .replace(/(\])\s*\}\s*\}\s*$/, '$1}')
        .replace(/\}\s*\}\s*$/, '}]');

      try {
        return JSON.parse(repaired);
      } catch (e2) {
        return null;
      }
    }
  }

  showTypingIndicator() {
    if (this.isTyping) return;

    this.isTyping = true;

    // Disable send button while AI is responding
    this.sendButton.disabled = true;

    const typingElement = document.createElement('div');
    typingElement.className = 'typing-indicator-container';
    typingElement.setAttribute('data-typing', 'true');

    // Move the badge here and add spinning class
    if (this.aiBadge) {
      this.aiBadge.classList.add('spinning');
      typingElement.appendChild(this.aiBadge);
    }

    this.messagesContainer.appendChild(typingElement);
    this.scrollToBottom();
  }

  hideTypingIndicator() {
    const typingElement = this.messagesContainer.querySelector('[data-typing="true"]');
    if (typingElement) {
      // Remove spinning class
      if (this.aiBadge) {
        this.aiBadge.classList.remove('spinning');
      }
      typingElement.remove();
    }
    this.isTyping = false;

    // Re-enable send button based on input content
    this.autoResizeTextarea();
  }

  async getAIResponse() {
    this.showTypingIndicator();

    try {
      const endpoint = 'https://hairstory-ai-chat.vercel.app/api/chat';

      // Build request body (system prompt is now in the API endpoint)
      const requestBody = {
        messages: this.conversationHistory,
        sessionId: this.sessionId,
        metadata: {
          source: 'web_component',
          environment: 'production'
        }
      };

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      this.hideTypingIndicator();

      if (data.error) {
        this.showErrorMessage(data.error);
      } else {
        this.addMessage(data.text, 'ai', data.recommendation);

        // Add AI response to conversation history
        // If there's text, add it. If there's a recommendation but no text,
        // create a summary for context in follow-up questions
        if (data.text && data.text.trim().length > 0) {
          this.conversationHistory.push({
            role: 'assistant',
            content: data.text
          });
        } else if (data.recommendation) {
          // Create a summary of the recommendation for conversation context
          const productNames = data.recommendation.products.map(p => p.name).join(', ');
          const summary = `I recommended the following products: ${productNames}. ${data.recommendation.intro || ''} ${data.recommendation.closing || ''}`;
          this.conversationHistory.push({
            role: 'assistant',
            content: summary.trim()
          });
        }
      }
    } catch (error) {
      console.error('Error calling AI API:', error);
      this.hideTypingIndicator();
      this.showErrorMessage('Sorry, I\'m having trouble connecting right now. Please try again in a moment.');
    }
  }

  showErrorMessage(message) {
    const errorElement = document.createElement('div');
    errorElement.className = 'error-message';
    errorElement.textContent = message;
    this.messagesContainer.appendChild(errorElement);
    this.scrollToBottom();
  }

  scrollToMessage(messageElement) {
    setTimeout(() => {
      // Find the previous message (user's question)
      const previousMessage = messageElement.previousElementSibling;
      const targetElement = (previousMessage && previousMessage.classList.contains('user'))
        ? previousMessage
        : messageElement;

      // Calculate scroll position relative to the messages container
      const containerTop = this.messagesContainer.offsetTop;
      const elementTop = targetElement.offsetTop;
      const scrollPosition = elementTop - containerTop;

      // Scroll the messages container, not the page
      this.messagesContainer.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
    }, 100);
  }

  scrollToBottom() {
    setTimeout(() => {
      this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;
    }, 100);
  }

  linkifyUrls(text) {
    // Convert URLs to clickable links
    // Stop at whitespace, angle brackets (HTML tags), or common punctuation at end of sentences
    const urlPattern = /(https?:\/\/[^\s<]+)/g;
    return text.replace(urlPattern, (url) => {
      // Remove trailing punctuation that's likely not part of the URL
      const cleanUrl = url.replace(/[.,;:!?]+$/, '');
      return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" style="color: #000; text-decoration: underline;">${cleanUrl}</a>`;
    });
  }

  async addCustomBundle(productSkus, button) {
    // Store original button state
    const originalText = button.innerHTML;

    try {
      // Show loading state
      button.disabled = true;
      button.innerHTML = 'ADDING TO CART...';

      // 1. Check for existing bundle
      const cartCheck = await fetch('/cart.js');
      const cart = await cartCheck.json();

      if (cart.items.some(item => item.properties?._bundle)) {
        throw new Error('Cart already contains a bundle. Only one bundle per order allowed.');
      }

      // 2. Get variant IDs from SKUs
      const bundleItems = [];
      for (const sku of productSkus) {
        // Find product data by SKU
        const productEntry = Object.values(PRODUCT_DATA).find(p => p.sku === sku);
        if (!productEntry || !productEntry.variantId || productEntry.variantId === 'TODO') {
          throw new Error(`Variant ID not found for SKU: ${sku}. Please add variant IDs to PRODUCT_DATA.`);
        }

        bundleItems.push({
          id: productEntry.variantId,
          quantity: 1,
          properties: {
            _bundle: 'true'
          }
        });
      }

      // 3. Add to cart using Shopify's cart API
      const cartPayload = {
        items: bundleItems,
        sections: 'v2-cart-drawer,v2-cart-icon-bubble,v2-cart-recommendations',
        sections_url: window.location.pathname
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartPayload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // 4. Disable bundle builder if present
      const bundleBuilder = document.querySelector('bundle-builder');
      if (bundleBuilder) {
        bundleBuilder.disableBundleBuilder();
      }

      // 5. Update cart drawer (v2 API)
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.renderSections(data.sections, 'add', 'Hair Chat Bundle');
        cartDrawer.open();
      }

      // Publish cart update event (for other components that listen)
      document.dispatchEvent(new CustomEvent('cart-update', {
        detail: {
          source: 'custom-bundle',
          cartData: data
        },
        bubbles: true
      }));

      // 6. Analytics
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          event: 'hairstory_add_bundle_to_cart',
          session_id: this.sessionId,
          product_skus: productSkus
        });
      }

      // Success state
      button.innerHTML = '✓ ADDED TO CART';

      return data;

    } catch (error) {
      console.error('[Add Bundle] Error:', error);

      // Show error state
      button.innerHTML = 'ERROR - TRY AGAIN';
      button.style.background = '#dc2626';

      // Reset button after 3 seconds
      setTimeout(() => {
        button.innerHTML = originalText;
        button.style.background = '#000';
        button.disabled = false;
      }, 3000);

      // Show error message to user
      alert(error.message || 'Failed to add bundle to cart. Please try again.');

      throw error;
    }
  }

  // ============================================================================
  // SAVE BUNDLE EMAIL CAPTURE
  // ============================================================================

  async handleSaveBundleSubmit(form) {
    const ctaContainer = form.closest('[data-save-bundle]');
    const emailInput = form.querySelector('.save-bundle-email');
    const submitBtn = form.querySelector('.save-bundle-submit');
    const email = emailInput.value.trim();

    // Validate email
    if (!email || !emailInput.checkValidity()) {
      emailInput.reportValidity();
      return;
    }

    // Show loading state
    const originalBtnText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = '...';

    try {
      await this.sendBundleToKlaviyo(email, ctaContainer);

      // Show success state
      ctaContainer.querySelector('.save-bundle-expanded').style.display = 'none';
      ctaContainer.querySelector('.save-bundle-success').style.display = 'block';

      // Fire GTM event
      if (typeof window !== 'undefined' && window.dataLayer) {
        const skus = JSON.parse(ctaContainer.dataset.productSkus || '[]');
        window.dataLayer.push({
          event: 'aichat_save_bundle_submitted',
          session_id: this.sessionId,
          product_skus: skus,
          email_captured: true
        });
      }
    } catch (err) {
      console.error('Error saving bundle:', err);
      submitBtn.textContent = 'Error';
      setTimeout(() => {
        submitBtn.textContent = originalBtnText;
        submitBtn.disabled = false;
      }, 2000);
    }
  }

  async sendBundleToKlaviyo(email, ctaContainer) {
    const skus = JSON.parse(ctaContainer.dataset.productSkus || '[]');

    // Build rich product array
    const products = skus.map(sku => {
      const entry = Object.values(PRODUCT_DATA).find(p => p.sku === sku);
      const aiProduct = this.lastRecommendation?.products?.find(p => {
        const pd = getProductData(p.name);
        return pd.sku === sku;
      });
      return entry ? {
        name: entry.name,
        handle: entry.handle,
        sku: entry.sku,
        price: entry.price,
        variantId: entry.variantId,
        productUrl: entry.productUrl,
        imageUrl: entry.imageUrl,
        description: aiProduct?.description || ''
      } : { sku };
    });

    if (window.klaviyo) {
      // Identify first to ensure profile exists with properties
      window.klaviyo.identify({
        '$email': email,
        'AI Chat Bundle': products.map(p => p.name).join(', '),
        'AI Chat Session': this.sessionId
      });
    }

    // Subscribe email to Klaviyo marketing (after identify)
    await subscribeToKlaviyo(email);

    if (window.klaviyo) {
      const totalPrice = products.reduce((sum, p) => sum + parseFloat((p.price || '0').replace('$', '')), 0);
      const discountRate = getBundleDiscountRate(products.length);
      const discountedPrice = totalPrice * (1 - discountRate);

      window.klaviyo.track('AI Chat Bundle Saved', {
        products: products,
        intro: this.lastRecommendationIntro || '',
        closing: this.lastRecommendationClosing || '',
        bundleBuilderUrl: this.lastRecommendationRoutineUrl || '',
        productCount: products.length,
        totalPrice: totalPrice.toFixed(2),
        discountPercent: (discountRate * 100).toFixed(0),
        discountedPrice: discountedPrice.toFixed(2),
        sessionId: this.sessionId
      });
    }
  }
}

customElements.define('hair-chat', HairChat);